import React, { useMemo, useCallback } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import TSTable, { EditButtonTableCell, DeleteButtonTableCell, SwitchTableCell, DateTableCell } from '@ts-core/components/Table';

import MediaItemThumbTableCell from '../MediaItemThumbTableCell';

import MediaItemStateCell from './MediaItemStateCell';

const MediaItemsTable = (props) => {
  const { mediaItems, loading, onSelectMediaItem, onEditMediaItem, onRemoveMediaItem, onToggleMediaItem, onReorderMediaItems } = props;
  const intl = useIntl();

  const getActionsCell = useCallback(
    (_value, _, mediaItem) => {
      return (
        <Box display="flex" justifyContent="flex-end">
          <EditButtonTableCell item={mediaItem} onClick={onEditMediaItem} />
          <Box width={24} />
          <DeleteButtonTableCell
            message={intl.formatMessage(
              {
                id: 'dialog.confirmRemoveItem.title',
              },
              { item: mediaItem.name }
            )}
            item={mediaItem}
            onConfirm={onRemoveMediaItem}
          />
        </Box>
      );
    },
    [intl, onEditMediaItem, onRemoveMediaItem]
  );

  const columns = useMemo(() => {
    return [
      {
        Header: '',
        accessor: '_id',
        valueTransformer: (_value, _, mediaItem) => <SwitchTableCell item={mediaItem} onChange={onToggleMediaItem} />,
      },
      {
        accessor: '_id',
        valueTransformer: (_value, _, mediaItem) => <MediaItemThumbTableCell mediaItem={mediaItem} />,
      },
      {
        Header: intl.formatMessage({ id: 'field.name.label' }),
        accessor: 'name',
      },
      {
        Header: intl.formatMessage({ id: 'media.availableFrom' }),
        accessor: 'availableFrom',
        valueTransformer: (value) => <DateTableCell date={value} />,
      },
      {
        Header: intl.formatMessage({ id: 'media.availableUpTo' }),
        accessor: 'availableUpTo',
        valueTransformer: (value) => <DateTableCell date={value} />,
      },
      {
        Header: intl.formatMessage({ id: 'media.state' }),
        accessor: 'processed',
        valueTransformer: (value) => <MediaItemStateCell processed={value} />,
      },
      { Header: '', accessor: '_id', valueTransformer: getActionsCell },
    ];
  }, [intl, getActionsCell, onToggleMediaItem]);

  return (
    <Box mt={1}>
      <TSTable data={mediaItems} loading={loading} columns={columns} onSelectRow={onSelectMediaItem} onSortEnd={onReorderMediaItems} />
    </Box>
  );
};

MediaItemsTable.propTypes = {
  mediaItems: PropTypes.array,
  loading: PropTypes.bool,

  onSelectMediaItem: PropTypes.func,
  onEditMediaItem: PropTypes.func,
  onRemoveMediaItem: PropTypes.func,
  onToggleMediaItem: PropTypes.func,
  onReorderMediaItems: PropTypes.func,
};

MediaItemsTable.defaultProps = {
  mediaItems: [],
  loading: false,

  onSelectMediaItem() {},
  onEditMediaItem() {},
  onRemoveMediaItem() {},
  onToggleMediaItem() {},
  onReorderMediaItems: undefined,
};

export default MediaItemsTable;
